import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AdminRoute = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check if user is admin - check both user object and ensure it's explicitly true
  if (!user || user.isAdmin !== true) {
    console.log('Admin access denied. User:', user, 'isAdmin:', user?.isAdmin);
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default AdminRoute; 